import React from "react";
import { useNavigate } from "react-router-dom";
import { Target, ArrowUpRight } from "lucide-react";
import { Button } from "../ui/button";
import { useS } from "../../lib/simple";

export function RecoCard({ priorities }) {
  const { s } = useS();
  const nav = useNavigate();
  return (
    <div className="lb-card p-5" data-testid="home-reco-card">
      <p className="font-display font-bold text-lg flex items-center gap-2"><Target size={18} className="text-neon" /> {s("reco_title")}</p>
      <ol className="mt-3 space-y-2">
        {priorities.slice(0, 3).map((p, i) => (
          <li key={i} className="flex items-start gap-3 text-sm" data-testid={`home-reco-${i}`}>
            <span className="shrink-0 w-6 h-6 rounded-full bg-white/10 text-xs font-bold flex items-center justify-center">{i + 1}</span>
            <span className="pt-0.5">{p.titre}</span>
          </li>
        ))}
      </ol>
      <Button onClick={() => nav("/app/diagnostic")} data-testid="home-reco-cta" variant="outline" className="w-full mt-4 rounded-full h-12 border-white/10 bg-white/5">
        {s("reco_cta")} <ArrowUpRight size={15} className="ml-1" />
      </Button>
    </div>
  );
}
